export default "__VITE_ASSET__Bqxwd0YO__"